export const NUMBER_INLINE_READ_EDIT_VIEW_BADGE =
	'issue-field-number-inline-edit-readview.ui.badge';
export const NUMBER_INLINE_EDIT_READ_VIEW_HOVER_CONTAINER =
	'issue-field-number-inline-edit-readview.ui.hover-container';
export const NUMBER_INLINE_EDIT_READ_VIEW_WRAPPER =
	'issue-field-number-inline-edit-readview.ui.wrapper';
